import api, { detailFromAxiosError } from "@/lib/api";

/** Mensaje estándar cuando no hay filas en pantalla para exportar. */
export const MSG_SIN_DATOS_EXPORTAR =
  "No hay datos en pantalla para exportar. Primero realice una validación.";

/**
 * Formatea fecha/hora local para encabezados de reporte (es-MX).
 */
export function formatFechaValidacionLocal(date = new Date()) {
  try {
    return date.toLocaleString("es-MX", {
      day: "2-digit",
      month: "2-digit",
      year: "numeric",
      hour: "2-digit",
      minute: "2-digit",
    });
  } catch {
    return date.toISOString().slice(0, 16).replace("T", " ");
  }
}

/**
 * Descarga un reporte laboral (Excel/PDF) vía blob — equivale al «Guardar como» del navegador.
 * La generación ocurre en el backend de forma asíncrona para no bloquear la UI.
 */
export async function downloadLaboralReport({
  endpoint,
  payload,
  fallbackFilename,
}) {
  const response = await api.post(endpoint, payload, {
    responseType: "blob",
    timeout: 120000,
  });
  const blob = response.data;
  if (!(blob instanceof Blob) || blob.size === 0) {
    throw new Error("El archivo generado está vacío.");
  }

  const cd =
    response.headers["content-disposition"] ||
    response.headers["Content-Disposition"] ||
    "";
  let filename = fallbackFilename;
  const quoted = cd.match(/filename="([^"]+)"/i);
  if (quoted?.[1]) filename = quoted[1];

  const url = URL.createObjectURL(blob);
  const anchor = document.createElement("a");
  anchor.href = url;
  anchor.download = filename;
  anchor.style.display = "none";
  document.body.appendChild(anchor);
  anchor.click();
  document.body.removeChild(anchor);
  setTimeout(() => URL.revokeObjectURL(url), 120000);

  return filename;
}

/** Traduce errores Axios (incl. blob JSON) a mensaje legible. */
export async function laboralExportErrorMessage(error) {
  const msg = await detailFromAxiosError(error);
  return msg || MSG_SIN_DATOS_EXPORTAR;
}
